import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-share",
  "use": "icon-nav-share-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav-share\">\n<path d=\"M3.125 11.875L3.125 3.125H6.875M16.875 13.1251V16.8751H13.125H3.125V13.1251\" stroke=\"#4E5969\" stroke-width=\"1.875\" stroke-linecap=\"square\" />\n<path d=\"M14.375 3.125L16.875 5.625H15.625C12.1732 5.625 9.375 8.42322 9.375 11.875\" stroke=\"#4E5969\" stroke-width=\"1.875\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol